import React from 'react';
import { getEnterpriseValueFormula } from 'common/formulas/math.js/ENTERPRISE_AND_EQUITY_VALUE';
import GridRowLabel from 'components/Grid/GridRowLabel';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import {
  BACKSOLVE_SUMMARY_TITLE,
  ENTERPISE_VALUE_TITLE,
  IMPLIED_EQUITY_VALUE_TITLE,
} from 'pages/Valuations/approaches/backsolveApproach/BacksolveSummaryTable/util/constants';
import { TABLE_HEADER_CONFIG } from 'pages/Valuations/approaches/backsolveApproach/constants';
import { ParserProps } from './types';

export default async ({ columns, rowConfig, tableData }: ParserProps) => {
  let cells: Record<string, Partial<ICell>> = {};
  const getExpr = (expr: string, columnLegend: string) => {
    if (expr) {
      return expr.replace(/@/g, `${columnLegend}`);
    }
    return '';
  };
  cells.A1 = {
    ...TABLE_HEADER_CONFIG,
    key: 'A1',
    value: BACKSOLVE_SUMMARY_TITLE,
    rowNumber: 1,
    colSpan: 2,
    expr: BACKSOLVE_SUMMARY_TITLE,
    largeHeader: true,
    checkPrevCol: true,
    valueViewer: (props: any) => <GridRowLabel {...props} />,
  };
  cells.A2 = {
    key: 'A2',
    rowNumber: 2,
    readOnly: true,
    dbType: 'string',
    expr: IMPLIED_EQUITY_VALUE_TITLE,
    value: IMPLIED_EQUITY_VALUE_TITLE,
  };
  cells.A3 = {
    key: 'A3',
    rowNumber: 3,
    readOnly: true,
    dbType: 'string',
    expr: ENTERPISE_VALUE_TITLE,
    value: ENTERPISE_VALUE_TITLE,
  };

  const VALUE_LEGEND = 'B';

  const { approach, primaryFinancials, constantsFinancialStatementIds } = tableData;
  const financialStatementId = approach.financial_statement;
  const hasConstantsRow = Boolean(
    financialStatementId && constantsFinancialStatementIds?.includes(financialStatementId)
  );

  rowConfig.forEach((row, rowIdx) => {
    const rowNumber = rowIdx + 1;
    const col = columns[1];
    const columnLegend = VALUE_LEGEND;
    const key = columnLegend + rowNumber;
    let expr = getExpr(row.expr as string, columnLegend);
    const value = col[row.alias];
    const customKey = row.alias;

    if (key === 'B3' && financialStatementId !== primaryFinancials?.id && hasConstantsRow) {
      const cash = `constants.ltm_cash_${financialStatementId}`;
      const debt = `constants.ltm_debt_${financialStatementId}`;
      expr = `=${getEnterpriseValueFormula('B2', cash, debt)}`;
    }

    cells = {
      ...cells,
      [key]: {
        ...row,
        expr,
        key,
        columnLegend,
        value,
        className: '',
        customKey,
      },
    };
  });
  return cells;
};
